module.exports = __webpack_public_path__ + "media/images/components/c02-page-footer/wave--lg-57be54a1ecc0bb0995937c28cb9fb490.svg";